/**
 * Safe Translate Drupal String.
 *
 * @format
 */
import { TranslationContext } from '../context/translation-context';
import { useContext } from 'react';

export const useSafeTranslate = (
  textBlob: string | undefined,
  useJson = true
): string | undefined | null => {
  const languageData = useContext(TranslationContext);
  if (typeof window.Drupal !== 'undefined') {
    if (useJson && textBlob && languageData) {
      const textBlobKey = textBlob.toLowerCase().trim().replace(/ /g, '-');
      if (languageData !== null && languageData[textBlobKey]) {
        return languageData[textBlobKey];
      }
    }

    if (!useJson) {
      return window.Drupal.t(textBlob);
    }
  }
  return textBlob;
};
